"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSignature = getSignature;
const enc_base64_1 = __importDefault(require("crypto-js/enc-base64"));
const hmac_sha256_1 = __importDefault(require("crypto-js/hmac-sha256"));
// note: path is the url path, not the full url
function getSignature({ path, apiKey, body, }) {
    if (apiKey) {
        let hashVal = `:${path}`;
        if (body && Object.keys(body).length > 0) {
            hashVal = `${JSON.stringify(body)}:${path}`;
        }
        return enc_base64_1.default.stringify((0, hmac_sha256_1.default)(hashVal, apiKey));
    }
    return "";
}
